import { render, staticRenderFns } from "./Callback.vue?vue&type=template&id=2b25c8d7&"
import script from "./Callback.ts?vue&type=script&lang=ts&"
export * from "./Callback.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports